import apiFetch from '../apiFetch'

export default function (token, ouId) {
  return apiFetch({ endPoint: `DossierType/Subtypes?organizedUnitID=${ouId}`, method: 'GET', body: null, token: token })
}
